// This file is auto-generated by @hey-api/openapi-ts

import type { Client, Options as Options2, TDataShape } from './client';
import { client } from './client.gen';
import type { AcceptInvitationData, AcceptInvitationErrors, AcceptInvitationResponses, ActivateUserData, ActivateUserErrors, ActivateUserResponses, AddCapaNoteData, AddCapaNoteErrors, AddCapaNoteResponses, AddEcrNoteData, AddEcrNoteErrors, AddEcrNoteResponses, AddNote2Data, AddNote2Errors, AddNote2Responses, AddNoteData, AddNoteErrors, AddNoteResponses, AdvanceCapaData, AdvanceCapaErrors, AdvanceCapaResponses, AdvanceEcrData, AdvanceEcrErrors, AdvanceEcrResponses, AuthFinishData, AuthFinishErrors, AuthFinishResponses, AuthStartData, AuthStartResponses, AvailableCriteriaData, AvailableCriteriaErrors, AvailableCriteriaResponses, BulkDownloadData, BulkDownloadErrors, BulkDownloadResponses, BulkSendData, BulkSendErrors, BulkSendResponses, BulkValidateData, BulkValidateErrors, BulkValidateResponses, CancelReviewData, CancelReviewErrors, CancelReviewResponses, ChangePasswordData, ChangePasswordErrors, ChangePasswordResponses, CheckMyPermissionsData, CheckMyPermissionsErrors, CheckMyPermissionsResponses, CheckPermissionsData, CheckPermissionsErrors, CheckPermissionsResponses, CreateCapaData, CreateCapaErrors, CreateCapaResponses, CreateDocumentContainerData, CreateDocumentContainerErrors, CreateDocumentContainerResponses, CreateDocumentTypeData, CreateDocumentTypeErrors, CreateDocumentTypeResponses, CreateEcrData, CreateEcrErrors, CreateEcrResponses, CreateFolderData, CreateFolderErrors, CreateFolderResponses, CreateInstrumentData, CreateInstrumentResponses, CreatePurchaseOrderData, CreatePurchaseOrderErrors, CreatePurchaseOrderResponses, CreateSupplierData, CreateSupplierErrors, CreateSupplierResponses, CreateTestRunData, CreateTestRunErrors, CreateTestRunResponses, CreateTokenData, CreateTokenErrors, CreateTokenResponses, CsrfTokenData, CsrfTokenResponses, Dashboard2Data, Dashboard2Responses, DashboardData, DashboardErrors, DashboardResponses, DeactivateUserData, DeactivateUserErrors, DeactivateUserResponses, DeleteDocumentContainerData, DeleteDocumentContainerErrors, DeleteDocumentContainerResponses, DeleteDocumentTypeData, DeleteDocumentTypeErrors, DeleteDocumentTypeResponses, DeleteDraftData, DeleteDraftErrors, DeleteDraftResponses, DeleteFolderData, DeleteFolderErrors, DeleteFolderResponses, DeleteInstrumentData, DeleteInstrumentErrors, DeleteInstrumentResponses, DeleteLogoData, DeleteLogoErrors, DeleteLogoResponses, DeleteNoteData, DeleteNoteErrors, DeleteNoteResponses, DeletePasskeyData, DeletePasskeyErrors, DeletePasskeyResponses, DeleteSupplierData, DeleteSupplierErrors, DeleteSupplierResponses, DeleteUserData, DeleteUserErrors, DeleteUserResponses, Disable2FaData, Disable2FaErrors, Disable2FaResponses, DownloadOriginalData, DownloadOriginalErrors, DownloadOriginalResponses, DownloadPdfData, DownloadPdfErrors, DownloadPdfResponses, EditNoteData, EditNoteErrors, EditNoteResponses, Enable2FaData, Enable2FaErrors, Enable2FaResponses, ExportAuditLogs2Data, ExportAuditLogs2Errors, ExportAuditLogs2Responses, ExportAuditLogsData, ExportAuditLogsErrors, ExportAuditLogsResponses, FailureAnalysisData, FailureAnalysisErrors, FailureAnalysisResponses, FailureDetailsData, FailureDetailsErrors, FailureDetailsResponses, FilterOptionsData, FilterOptionsErrors, FilterOptionsResponses, Generate2FaData, Generate2FaErrors, Generate2FaResponses, GetAccessibleResourcesData, GetAccessibleResourcesErrors, GetAccessibleResourcesResponses, GetAccessibleUserIdsData, GetAccessibleUserIdsErrors, GetAccessibleUserIdsResponses, GetCapaDashboardData, GetCapaDashboardErrors, GetCapaDashboardResponses, GetCapaData, GetCapaErrors, GetCapaExportData, GetCapaExportErrors, GetCapaExportResponses, GetCapaPdfData, GetCapaPdfErrors, GetCapaPdfResponses, GetCapaResponses, GetCapaSettingsData, GetCapaSettingsErrors, GetCapaSettingsResponses, GetDocumentContainerData, GetDocumentContainerErrors, GetDocumentContainerResponses, GetEcrDashboardData, GetEcrDashboardErrors, GetEcrDashboardResponses, GetEcrData, GetEcrErrors, GetEcrExportData, GetEcrExportErrors, GetEcrExportResponses, GetEcrPdfData, GetEcrPdfErrors, GetEcrPdfResponses, GetEcrResponses, GetFolderContentsData, GetFolderContentsErrors, GetFolderContentsResponses, GetInstrumentData, GetInstrumentErrors, GetInstrumentResponses, GetLogoData, GetLogoErrors, GetLogoResponses, GetMetadata2Data, GetMetadata2Errors, GetMetadata2Responses, GetMetadataData, GetMetadataErrors, GetMetadataResponses, GetMyAccessibleResourcesData, GetMyAccessibleResourcesErrors, GetMyAccessibleResourcesResponses, GetMyPermissionsData, GetMyPermissionsErrors, GetMyPermissionsResponses, GetPowerDataData, GetPowerDataErrors, GetPowerDataResponses, GetProfileData, GetProfileErrors, GetProfileResponses, GetRunData, GetRunErrors, GetRunResponses, GetSettingsData, GetSettingsErrors, GetSettingsResponses, GetSupplierData, GetSupplierErrors, GetSupplierResponses, GetTestRunData, GetTestRunErrors, GetTestRunResponses, GetUserPermissionsData, GetUserPermissionsErrors, GetUserPermissionsResponses, GetUserStatisticsData, GetUserStatisticsErrors, GetUserStatisticsResponses, GrantPermissionsData, GrantPermissionsErrors, GrantPermissionsResponses, HealthData, HealthDetailedData, HealthDetailedResponses, HealthResponses, ListActiveUsersData, ListActiveUsersResponses, ListAuditLogs2Data, ListAuditLogs2Errors, ListAuditLogs2Responses, ListAuditLogsData, ListAuditLogsErrors, ListAuditLogsResponses, ListCapaHistoryData, ListCapaHistoryErrors, ListCapaHistoryResponses, ListCapasData, ListCapasErrors, ListCapasResponses, ListDocumentContainersData, ListDocumentContainersErrors, ListDocumentContainersResponses, ListDocumentTypesData, ListDocumentTypesErrors, ListDocumentTypesResponses, ListEcrHistoryData, ListEcrHistoryErrors, ListEcrHistoryResponses, ListEcrsData, ListEcrsErrors, ListEcrsResponses, ListInstrumentsData, ListInstrumentsResponses, ListInvitationsData, ListInvitationsErrors, ListInvitationsResponses, ListPasskeysData, ListPasskeysErrors, ListPasskeysResponses, ListPdfStatusData, ListPdfStatusErrors, ListPdfStatusResponses, ListPendingReviewsData, ListPendingReviewsErrors, ListPendingReviewsResponses, ListPermissionsData, ListPermissionsErrors, ListPermissionsResponses, ListRootFoldersData, ListRootFoldersErrors, ListRootFoldersResponses, ListRunsData, ListRunsErrors, ListRunsResponses, ListSuppliersData, ListSuppliersErrors, ListSuppliersResponses, ListTestRunsData, ListTestRunsErrors, ListTestRunsResponses, ListTokensData, ListTokensErrors, ListTokensResponses, ListUsersData, ListUsersErrors, ListUsersResponses, LiveData, LiveResponses, Login2FaData, Login2FaErrors, Login2FaResponses, LoginData, LoginErrors, LoginResponses, LogoutData, LogoutErrors, LogoutResponses, MacLookupData, MacLookupErrors, MacLookupResponses, MoveFolderData, MoveFolderErrors, MoveFolderResponses, ObsoleteDocumentData, ObsoleteDocumentErrors, ObsoleteDocumentResponses, PasswordRecoveryData, PasswordRecoveryResponses, PasswordResetData, PasswordResetErrors, PasswordResetResponses, PdfStatusCountData, PdfStatusCountErrors, PdfStatusCountResponses, PerformanceAnalysisData, PerformanceAnalysisErrors, PerformanceAnalysisResponses, PerformanceOverviewData, PerformanceOverviewErrors, PerformanceOverviewResponses, PowerMetadataData, PowerMetadataErrors, PowerMetadataResponses, PreviewPurchaseOrderData, PreviewPurchaseOrderErrors, PreviewPurchaseOrderResponses, ReadyData, ReadyErrors, ReadyResponses, ReclassifyEcrData, ReclassifyEcrErrors, ReclassifyEcrResponses, RecordCalibrationData, RecordCalibrationErrors, RecordCalibrationResponses, RegeneratePdfData, RegeneratePdfErrors, RegeneratePdfResponses, RegisterFinishData, RegisterFinishErrors, RegisterFinishResponses, RegisterStartData, RegisterStartErrors, RegisterStartResponses, ReinstateDocumentData, ReinstateDocumentErrors, ReinstateDocumentResponses, RenameFolderData, RenameFolderErrors, RenameFolderResponses, RetryAllFailedData, RetryAllFailedErrors, RetryAllFailedResponses, RevokeInvitationData, RevokeInvitationErrors, RevokeInvitationResponses, RevokePermissionsData, RevokePermissionsErrors, RevokePermissionsResponses, RevokeTokenData, RevokeTokenErrors, RevokeTokenResponses, SearchData, SearchErrors, SearchResponses, SendForReviewData, SendForReviewErrors, SendForReviewResponses, SendInvitationData, SendInvitationErrors, SendInvitationResponses, StreamPowerDataData, StreamPowerDataErrors, StreamPowerDataResponses, SubmitReviewData, SubmitReviewErrors, SubmitReviewResponses, SuggestCodeData, SuggestCodeErrors, SuggestCodeResponses, TimelineData, TimelineErrors, TimelineResponses, UpdateCapaData, UpdateCapaErrors, UpdateCapaResponses, UpdateCapaSettingsData, UpdateCapaSettingsErrors, UpdateCapaSettingsResponses, UpdateDocumentContainerData, UpdateDocumentContainerErrors, UpdateDocumentContainerResponses, UpdateDocumentStatusData, UpdateDocumentStatusErrors, UpdateDocumentStatusResponses, UpdateDocumentTypeData, UpdateDocumentTypeErrors, UpdateDocumentTypeResponses, UpdateEcrData, UpdateEcrErrors, UpdateEcrResponses, UpdateInstrumentData, UpdateInstrumentErrors, UpdateInstrumentResponses, UpdateProfileData, UpdateProfileErrors, UpdateProfileResponses, UpdateSettingsData, UpdateSettingsErrors, UpdateSettingsResponses, UpdateSupplierData, UpdateSupplierErrors, UpdateSupplierResponses, UploadDocumentData, UploadDocumentErrors, UploadDocumentResponses, UploadLogoData, UploadLogoErrors, UploadLogoResponses, UploadPowerDataData, UploadPowerDataErrors, UploadPowerDataResponses, VerifyChain2Data, VerifyChain2Errors, VerifyChain2Responses, VerifyChainData, VerifyChainErrors, VerifyChainResponses, VersionData, VersionResponses } from './types.gen';

export type Options<TData extends TDataShape = TDataShape, ThrowOnError extends boolean = boolean> = Options2<TData, ThrowOnError> & {
    /**
     * You can provide a client instance returned by `createClient()` instead of
     * individual options. This might be also useful if you want to implement a
     * custom client.
     */
    client?: Client;
    /**
     * You can pass arbitrary values through the `meta` object. This can be
     * used to access values that aren't defined as part of the SDK function.
     */
    meta?: Record<string, unknown>;
};

/**
 * List test runs with optional filters.
 */
export const listTestRuns = <ThrowOnError extends boolean = false>(options?: Options<ListTestRunsData, ThrowOnError>) => (options?.client ?? client).get<ListTestRunsResponses, ListTestRunsErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/ate/v1/test-runs',
    ...options
});

/**
 * Create a new test run.
 */
export const createTestRun = <ThrowOnError extends boolean = false>(options: Options<CreateTestRunData, ThrowOnError>) => (options.client ?? client).post<CreateTestRunResponses, CreateTestRunErrors, ThrowOnError>({
    url: '/api/ate/v1/test-runs',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Look up the most recent MAC address for a device.
 */
export const macLookup = <ThrowOnError extends boolean = false>(options: Options<MacLookupData, ThrowOnError>) => (options.client ?? client).get<MacLookupResponses, MacLookupErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/ate/v1/test-runs/serial/{sn}/mac-address',
    ...options
});

/**
 * Get a test run by ID (full detail including data JSONB).
 */
export const getTestRun = <ThrowOnError extends boolean = false>(options: Options<GetTestRunData, ThrowOnError>) => (options.client ?? client).get<GetTestRunResponses, GetTestRunErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/ate/v1/test-runs/{id}',
    ...options
});

/**
 * Get power data metadata for a test run.
 */
export const getPowerData = <ThrowOnError extends boolean = false>(options: Options<GetPowerDataData, ThrowOnError>) => (options.client ?? client).get<GetPowerDataResponses, GetPowerDataErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/ate/v1/test-runs/{id}/power-data',
    ...options
});

/**
 * Upload power data for a test run.
 */
export const uploadPowerData = <ThrowOnError extends boolean = false>(options: Options<UploadPowerDataData, ThrowOnError>) => (options.client ?? client).post<UploadPowerDataResponses, UploadPowerDataErrors, ThrowOnError>({
    url: '/api/ate/v1/test-runs/{id}/power-data',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List all ATE API tokens.
 */
export const listTokens = <ThrowOnError extends boolean = false>(options?: Options<ListTokensData, ThrowOnError>) => (options?.client ?? client).get<ListTokensResponses, ListTokensErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/ate/tokens',
    ...options
});

/**
 * Create a new ATE API token.
 *
 * The raw token hex is returned **once** in the response and cannot be retrieved again.
 */
export const createToken = <ThrowOnError extends boolean = false>(options: Options<CreateTokenData, ThrowOnError>) => (options.client ?? client).post<CreateTokenResponses, CreateTokenErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/ate/tokens',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Revoke an ATE API token.
 */
export const revokeToken = <ThrowOnError extends boolean = false>(options: Options<RevokeTokenData, ThrowOnError>) => (options.client ?? client).post<RevokeTokenResponses, RevokeTokenErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/ate/tokens/{id}/revoke',
    ...options
});

/**
 * List audit logs with pagination and optional filters.
 *
 * Supports filtering by action, resource type, resource ID, severity,
 * date range, and user search. Filters accept comma-separated values
 * for multi-value matching. Combined with standard `ListParams` pagination.
 */
export const listAuditLogs = <ThrowOnError extends boolean = false>(options?: Options<ListAuditLogsData, ThrowOnError>) => (options?.client ?? client).get<ListAuditLogsResponses, ListAuditLogsErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/audit-logs',
    ...options
});

/**
 * Export audit logs as a JSON file download.
 *
 * Applies the same filters as `list_audit_logs` but returns ALL matching
 * rows (no pagination) as a downloadable JSON attachment.
 */
export const exportAuditLogs = <ThrowOnError extends boolean = false>(options?: Options<ExportAuditLogsData, ThrowOnError>) => (options?.client ?? client).get<ExportAuditLogsResponses, ExportAuditLogsErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/audit-logs/export',
    ...options
});

/**
 * Get available filter metadata for audit log UI controls.
 *
 * Returns lists of valid actions, resource types, and severity levels
 * that can be used in filter dropdowns.
 */
export const getMetadata = <ThrowOnError extends boolean = false>(options?: Options<GetMetadataData, ThrowOnError>) => (options?.client ?? client).get<GetMetadataResponses, GetMetadataErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/audit-logs/metadata',
    ...options
});

/**
 * Verify the integrity of the entire audit hash chain.
 *
 * Loads all audit log entries and verifies each entry's HMAC signature
 * plus the hash chain linking consecutive entries.
 */
export const verifyChain = <ThrowOnError extends boolean = false>(options?: Options<VerifyChainData, ThrowOnError>) => (options?.client ?? client).post<VerifyChainResponses, VerifyChainErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/audit-logs/verify',
    ...options
});

/**
 * List document types (paginated).
 */
export const listDocumentTypes = <ThrowOnError extends boolean = false>(options?: Options<ListDocumentTypesData, ThrowOnError>) => (options?.client ?? client).get<ListDocumentTypesResponses, ListDocumentTypesErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/document-types',
    ...options
});

/**
 * Create a new document type.
 */
export const createDocumentType = <ThrowOnError extends boolean = false>(options: Options<CreateDocumentTypeData, ThrowOnError>) => (options.client ?? client).post<CreateDocumentTypeResponses, CreateDocumentTypeErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/document-types',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete a document type.
 *
 * Fails if any document containers reference this type.
 */
export const deleteDocumentType = <ThrowOnError extends boolean = false>(options: Options<DeleteDocumentTypeData, ThrowOnError>) => (options.client ?? client).delete<DeleteDocumentTypeResponses, DeleteDocumentTypeErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/document-types/{id}',
    ...options
});

/**
 * Update a document type.
 */
export const updateDocumentType = <ThrowOnError extends boolean = false>(options: Options<UpdateDocumentTypeData, ThrowOnError>) => (options.client ?? client).put<UpdateDocumentTypeResponses, UpdateDocumentTypeErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/document-types/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List documents by PDF generation status (admin only).
 *
 * Returns documents that have non-COMPLETED PDF generation, enriched with
 * container info and creator name. Supports pagination, sorting, and filtering.
 */
export const listPdfStatus = <ThrowOnError extends boolean = false>(options?: Options<ListPdfStatusData, ThrowOnError>) => (options?.client ?? client).get<ListPdfStatusResponses, ListPdfStatusErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/documents/pdf-status',
    ...options
});

/**
 * Count documents with PENDING or FAILED PDF generation (admin only).
 *
 * Used for the sidebar badge indicator.
 */
export const pdfStatusCount = <ThrowOnError extends boolean = false>(options?: Options<PdfStatusCountData, ThrowOnError>) => (options?.client ?? client).get<PdfStatusCountResponses, PdfStatusCountErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/documents/pdf-status/count',
    ...options
});

/**
 * Retry PDF generation for all FAILED documents (admin only).
 */
export const retryAllFailed = <ThrowOnError extends boolean = false>(options?: Options<RetryAllFailedData, ThrowOnError>) => (options?.client ?? client).post<RetryAllFailedResponses, RetryAllFailedErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/documents/pdf-status/retry-all',
    ...options
});

/**
 * List all invitations (paginated).
 *
 * Returns active (non-archived) invitations sorted by `created_at` descending.
 * Supports text search on email and status filter (`pending`, `accepted`, `expired`).
 */
export const listInvitations = <ThrowOnError extends boolean = false>(options?: Options<ListInvitationsData, ThrowOnError>) => (options?.client ?? client).get<ListInvitationsResponses, ListInvitationsErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/invitations',
    ...options
});

/**
 * Send a single invitation.
 *
 * Creates an invitation record for the given email address. The email must not
 * already be registered as a user or have an active (non-archived, non-expired)
 * invitation. Returns a message on success.
 */
export const sendInvitation = <ThrowOnError extends boolean = false>(options: Options<SendInvitationData, ThrowOnError>) => (options.client ?? client).post<SendInvitationResponses, SendInvitationErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/invitations',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Send bulk invitations.
 *
 * Attempts to create an invitation for each email address. Emails that are
 * already registered or already have active invitations are skipped and
 * reported in the `failed` map.
 */
export const bulkSend = <ThrowOnError extends boolean = false>(options: Options<BulkSendData, ThrowOnError>) => (options.client ?? client).post<BulkSendResponses, BulkSendErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/invitations/bulk',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Validate emails for bulk invitation.
 *
 * For each email, checks format validity, whether it is already registered,
 * and whether an active invitation already exists. Returns categorized results.
 */
export const bulkValidate = <ThrowOnError extends boolean = false>(options: Options<BulkValidateData, ThrowOnError>) => (options.client ?? client).post<BulkValidateResponses, BulkValidateErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/invitations/bulk/validate',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Revoke (archive) an invitation.
 *
 * Soft-deletes the invitation by setting `archived_at` and `archived_by_id`.
 * Returns a message on success.
 */
export const revokeInvitation = <ThrowOnError extends boolean = false>(options: Options<RevokeInvitationData, ThrowOnError>) => (options.client ?? client).delete<RevokeInvitationResponses, RevokeInvitationErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/invitations/{id}',
    ...options
});

/**
 * List all users (admin only).
 *
 * Returns a paginated list of users with optional search and active-status filtering.
 */
export const listUsers = <ThrowOnError extends boolean = false>(options?: Options<ListUsersData, ThrowOnError>) => (options?.client ?? client).get<ListUsersResponses, ListUsersErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/users',
    ...options
});

/**
 * Delete or archive a user (admin only).
 *
 * Hard-deletes the specified user.
 * Cannot delete yourself. Cannot delete the last admin.
 */
export const deleteUser = <ThrowOnError extends boolean = false>(options: Options<DeleteUserData, ThrowOnError>) => (options.client ?? client).delete<DeleteUserResponses, DeleteUserErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/users/{user_id}',
    ...options
});

/**
 * Activate a user (admin only).
 *
 * Sets the user's `is_active` flag to `true`.
 */
export const activateUser = <ThrowOnError extends boolean = false>(options: Options<ActivateUserData, ThrowOnError>) => (options.client ?? client).put<ActivateUserResponses, ActivateUserErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/users/{user_id}/activate',
    ...options
});

/**
 * Deactivate a user (admin only).
 *
 * Sets the user's `is_active` flag to `false`. Cannot deactivate yourself.
 */
export const deactivateUser = <ThrowOnError extends boolean = false>(options: Options<DeactivateUserData, ThrowOnError>) => (options.client ?? client).put<DeactivateUserResponses, DeactivateUserErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/users/{user_id}/deactivate',
    ...options
});

/**
 * Get user activity statistics (admin only).
 *
 * Returns audit activity counts and account age for a specific user.
 */
export const getUserStatistics = <ThrowOnError extends boolean = false>(options: Options<GetUserStatisticsData, ThrowOnError>) => (options.client ?? client).get<GetUserStatisticsResponses, GetUserStatisticsErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/users/{user_id}/statistics',
    ...options
});

/**
 * Dashboard with aggregate stats and recent runs.
 */
export const dashboard = <ThrowOnError extends boolean = false>(options?: Options<DashboardData, ThrowOnError>) => (options?.client ?? client).get<DashboardResponses, DashboardErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/ate/dashboard',
    ...options
});

/**
 * Failure analysis: aggregated failure statistics with yield, severity, period comparison.
 */
export const failureAnalysis = <ThrowOnError extends boolean = false>(options?: Options<FailureAnalysisData, ThrowOnError>) => (options?.client ?? client).get<FailureAnalysisResponses, FailureAnalysisErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/ate/failure-analysis',
    ...options
});

/**
 * Failure details for a specific criterion with server-side pagination.
 */
export const failureDetails = <ThrowOnError extends boolean = false>(options: Options<FailureDetailsData, ThrowOnError>) => (options.client ?? client).get<FailureDetailsResponses, FailureDetailsErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/ate/failure-details/{criterion}',
    ...options
});

export const filterOptions = <ThrowOnError extends boolean = false>(options?: Options<FilterOptionsData, ThrowOnError>) => (options?.client ?? client).get<FilterOptionsResponses, FilterOptionsErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/ate/filter-options',
    ...options
});

/**
 * Performance analysis: time-series data with spec limits, Cp/Cpk, yield.
 */
export const performanceAnalysis = <ThrowOnError extends boolean = false>(options: Options<PerformanceAnalysisData, ThrowOnError>) => (options.client ?? client).get<PerformanceAnalysisResponses, PerformanceAnalysisErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/ate/performance-analysis',
    ...options
});

/**
 * List available criteria for performance analysis (with unit + type).
 */
export const availableCriteria = <ThrowOnError extends boolean = false>(options?: Options<AvailableCriteriaData, ThrowOnError>) => (options?.client ?? client).get<AvailableCriteriaResponses, AvailableCriteriaErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/ate/performance-analysis/criteria',
    ...options
});

/**
 * Performance overview: aggregated metrics for all criteria.
 */
export const performanceOverview = <ThrowOnError extends boolean = false>(options?: Options<PerformanceOverviewData, ThrowOnError>) => (options?.client ?? client).get<PerformanceOverviewResponses, PerformanceOverviewErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/ate/performance-analysis/overview',
    ...options
});

/**
 * Paginated test run listing with filters.
 */
export const listRuns = <ThrowOnError extends boolean = false>(options?: Options<ListRunsData, ThrowOnError>) => (options?.client ?? client).get<ListRunsResponses, ListRunsErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/ate/runs',
    ...options
});

/**
 * Get a test run by ID (full detail).
 */
export const getRun = <ThrowOnError extends boolean = false>(options: Options<GetRunData, ThrowOnError>) => (options.client ?? client).get<GetRunResponses, GetRunErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/ate/runs/{id}',
    ...options
});

/**
 * Stream power data binary (download from Azure, strip PCOC header).
 */
export const streamPowerData = <ThrowOnError extends boolean = false>(options: Options<StreamPowerDataData, ThrowOnError>) => (options.client ?? client).get<StreamPowerDataResponses, StreamPowerDataErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/ate/runs/{id}/power-data',
    ...options
});

/**
 * Power metadata with phase markers extracted from test sequences.
 */
export const powerMetadata = <ThrowOnError extends boolean = false>(options: Options<PowerMetadataData, ThrowOnError>) => (options.client ?? client).get<PowerMetadataResponses, PowerMetadataErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/ate/runs/{id}/power-metadata',
    ...options
});

/**
 * Daily test counts for the full history (used for timeline brush chart).
 */
export const timeline = <ThrowOnError extends boolean = false>(options?: Options<TimelineData, ThrowOnError>) => (options?.client ?? client).get<TimelineResponses, TimelineErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/ate/timeline',
    ...options
});

/**
 * List audit logs with pagination and optional filters.
 *
 * Supports filtering by action, resource type, resource ID, severity,
 * date range, and user search. Filters accept comma-separated values
 * for multi-value matching. Combined with standard `ListParams` pagination.
 */
export const listAuditLogs2 = <ThrowOnError extends boolean = false>(options?: Options<ListAuditLogs2Data, ThrowOnError>) => (options?.client ?? client).get<ListAuditLogs2Responses, ListAuditLogs2Errors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/audit-logs',
    ...options
});

/**
 * Export audit logs as a JSON file download.
 *
 * Applies the same filters as `list_audit_logs` but returns ALL matching
 * rows (no pagination) as a downloadable JSON attachment.
 */
export const exportAuditLogs2 = <ThrowOnError extends boolean = false>(options?: Options<ExportAuditLogs2Data, ThrowOnError>) => (options?.client ?? client).get<ExportAuditLogs2Responses, ExportAuditLogs2Errors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/audit-logs/export',
    ...options
});

/**
 * Get available filter metadata for audit log UI controls.
 *
 * Returns lists of valid actions, resource types, and severity levels
 * that can be used in filter dropdowns.
 */
export const getMetadata2 = <ThrowOnError extends boolean = false>(options?: Options<GetMetadata2Data, ThrowOnError>) => (options?.client ?? client).get<GetMetadata2Responses, GetMetadata2Errors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/audit-logs/metadata',
    ...options
});

/**
 * Verify the integrity of the entire audit hash chain.
 *
 * Loads all audit log entries and verifies each entry's HMAC signature
 * plus the hash chain linking consecutive entries.
 */
export const verifyChain2 = <ThrowOnError extends boolean = false>(options?: Options<VerifyChain2Data, ThrowOnError>) => (options?.client ?? client).post<VerifyChain2Responses, VerifyChain2Errors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/audit-logs/verify',
    ...options
});

/**
 * Accept an invitation and create a new user account.
 */
export const acceptInvitation = <ThrowOnError extends boolean = false>(options: Options<AcceptInvitationData, ThrowOnError>) => (options.client ?? client).post<AcceptInvitationResponses, AcceptInvitationErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/auth/accept-invitation',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Authenticate and receive a JWT token.
 */
export const login = <ThrowOnError extends boolean = false>(options: Options<LoginData, ThrowOnError>) => (options.client ?? client).post<LoginResponses, LoginErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/auth/login',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Complete two-factor authentication login.
 */
export const login2Fa = <ThrowOnError extends boolean = false>(options: Options<Login2FaData, ThrowOnError>) => (options.client ?? client).post<Login2FaResponses, Login2FaErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/auth/login/2fa',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Log out the current user by blacklisting their token.
 */
export const logout = <ThrowOnError extends boolean = false>(options?: Options<LogoutData, ThrowOnError>) => (options?.client ?? client).post<LogoutResponses, LogoutErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/auth/logout',
    ...options
});

/**
 * Get the current authenticated user's profile.
 */
export const getProfile = <ThrowOnError extends boolean = false>(options?: Options<GetProfileData, ThrowOnError>) => (options?.client ?? client).get<GetProfileResponses, GetProfileErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/auth/me',
    ...options
});

/**
 * Complete passkey authentication and issue a JWT.
 */
export const authFinish = <ThrowOnError extends boolean = false>(options: Options<AuthFinishData, ThrowOnError>) => (options.client ?? client).post<AuthFinishResponses, AuthFinishErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/auth/passkey/finish',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Start passkey authentication.
 *
 * Accepts the user's email. If the user has registered passkeys, returns
 * `WebAuthn` request options with `allowCredentials` populated so that
 * password managers can match the credential. If the user has no passkeys
 * (or the email is unknown), returns `{ has_passkeys: false }` without
 * revealing whether the email exists.
 */
export const authStart = <ThrowOnError extends boolean = false>(options: Options<AuthStartData, ThrowOnError>) => (options.client ?? client).post<AuthStartResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/auth/passkey/start',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Request a password reset email.
 *
 * Always returns success to prevent email enumeration.
 */
export const passwordRecovery = <ThrowOnError extends boolean = false>(options: Options<PasswordRecoveryData, ThrowOnError>) => (options.client ?? client).post<PasswordRecoveryResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/auth/password-recovery',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Reset password using a token received via email.
 */
export const passwordReset = <ThrowOnError extends boolean = false>(options: Options<PasswordResetData, ThrowOnError>) => (options.client ?? client).post<PasswordResetResponses, PasswordResetErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/auth/password-reset',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List calibration instruments (paginated, searchable, filterable).
 */
export const listInstruments = <ThrowOnError extends boolean = false>(options?: Options<ListInstrumentsData, ThrowOnError>) => (options?.client ?? client).get<ListInstrumentsResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/calibration',
    ...options
});

/**
 * Create a calibration instrument.
 */
export const createInstrument = <ThrowOnError extends boolean = false>(options: Options<CreateInstrumentData, ThrowOnError>) => (options.client ?? client).post<CreateInstrumentResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/calibration',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get dashboard statistics.
 */
export const dashboard2 = <ThrowOnError extends boolean = false>(options?: Options<Dashboard2Data, ThrowOnError>) => (options?.client ?? client).get<Dashboard2Responses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/calibration/dashboard',
    ...options
});

/**
 * Delete an instrument (sets status to `OUT_OF_SERVICE`).
 */
export const deleteInstrument = <ThrowOnError extends boolean = false>(options: Options<DeleteInstrumentData, ThrowOnError>) => (options.client ?? client).delete<DeleteInstrumentResponses, DeleteInstrumentErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/calibration/{id}',
    ...options
});

/**
 * Get instrument by ID with calibration history.
 */
export const getInstrument = <ThrowOnError extends boolean = false>(options: Options<GetInstrumentData, ThrowOnError>) => (options.client ?? client).get<GetInstrumentResponses, GetInstrumentErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/calibration/{id}',
    ...options
});

/**
 * Update an instrument.
 */
export const updateInstrument = <ThrowOnError extends boolean = false>(options: Options<UpdateInstrumentData, ThrowOnError>) => (options.client ?? client).put<UpdateInstrumentResponses, UpdateInstrumentErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/calibration/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Add a note to an instrument's history.
 */
export const addNote = <ThrowOnError extends boolean = false>(options: Options<AddNoteData, ThrowOnError>) => (options.client ?? client).post<AddNoteResponses, AddNoteErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/calibration/{id}/notes',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Record a calibration event.
 *
 * Updates `last_calibrated`, recalculates due date, and updates certificate reference.
 */
export const recordCalibration = <ThrowOnError extends boolean = false>(options: Options<RecordCalibrationData, ThrowOnError>) => (options.client ?? client).post<RecordCalibrationResponses, RecordCalibrationErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/calibration/{id}/record',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List CAPAs with pagination, search, and filters.
 */
export const listCapas = <ThrowOnError extends boolean = false>(options?: Options<ListCapasData, ThrowOnError>) => (options?.client ?? client).get<ListCapasResponses, ListCapasErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/capas',
    ...options
});

/**
 * Create a new CAPA.
 */
export const createCapa = <ThrowOnError extends boolean = false>(options: Options<CreateCapaData, ThrowOnError>) => (options.client ?? client).post<CreateCapaResponses, CreateCapaErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/capas',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get CAPA dashboard data.
 */
export const getCapaDashboard = <ThrowOnError extends boolean = false>(options?: Options<GetCapaDashboardData, ThrowOnError>) => (options?.client ?? client).get<GetCapaDashboardResponses, GetCapaDashboardErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/capas/dashboard',
    ...options
});

/**
 * Export CAPAs as CSV or JSON.
 */
export const getCapaExport = <ThrowOnError extends boolean = false>(options?: Options<GetCapaExportData, ThrowOnError>) => (options?.client ?? client).get<GetCapaExportResponses, GetCapaExportErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/capas/export',
    ...options
});

/**
 * Get CAPA settings.
 */
export const getCapaSettings = <ThrowOnError extends boolean = false>(options?: Options<GetCapaSettingsData, ThrowOnError>) => (options?.client ?? client).get<GetCapaSettingsResponses, GetCapaSettingsErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/capas/settings',
    ...options
});

/**
 * Update CAPA settings (admin only).
 */
export const updateCapaSettings = <ThrowOnError extends boolean = false>(options: Options<UpdateCapaSettingsData, ThrowOnError>) => (options.client ?? client).put<UpdateCapaSettingsResponses, UpdateCapaSettingsErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/capas/settings',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get CAPA detail with history.
 */
export const getCapa = <ThrowOnError extends boolean = false>(options: Options<GetCapaData, ThrowOnError>) => (options.client ?? client).get<GetCapaResponses, GetCapaErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/capas/{car_number}',
    ...options
});

/**
 * Update CAPA fields with diff tracking.
 */
export const updateCapa = <ThrowOnError extends boolean = false>(options: Options<UpdateCapaData, ThrowOnError>) => (options.client ?? client).put<UpdateCapaResponses, UpdateCapaErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/capas/{car_number}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Advance CAPA through workflow stages.
 */
export const advanceCapa = <ThrowOnError extends boolean = false>(options: Options<AdvanceCapaData, ThrowOnError>) => (options.client ?? client).post<AdvanceCapaResponses, AdvanceCapaErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/capas/{car_number}/advance',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List history entries for a CAPA (newest first).
 */
export const listCapaHistory = <ThrowOnError extends boolean = false>(options: Options<ListCapaHistoryData, ThrowOnError>) => (options.client ?? client).get<ListCapaHistoryResponses, ListCapaHistoryErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/capas/{car_number}/history',
    ...options
});

/**
 * Add a note to a CAPA's history.
 */
export const addCapaNote = <ThrowOnError extends boolean = false>(options: Options<AddCapaNoteData, ThrowOnError>) => (options.client ?? client).post<AddCapaNoteResponses, AddCapaNoteErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/capas/{car_number}/history',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Export a single CAPA as PDF.
 */
export const getCapaPdf = <ThrowOnError extends boolean = false>(options: Options<GetCapaPdfData, ThrowOnError>) => (options.client ?? client).get<GetCapaPdfResponses, GetCapaPdfErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/capas/{car_number}/pdf',
    ...options
});

/**
 * Generate a CSRF token.
 *
 * Returns an HMAC-signed CSRF token in the format `{timestamp}:{random_hex}:{signature}`.
 * Returns an HMAC-signed CSRF token.
 *
 * - `timestamp` — Unix epoch seconds
 * - `random_hex` — 16 random bytes, hex-encoded (32 chars)
 * - `signature` — HMAC-SHA256 of `{timestamp}:{random_hex}`, hex-encoded (64 chars)
 */
export const csrfToken = <ThrowOnError extends boolean = false>(options?: Options<CsrfTokenData, ThrowOnError>) => (options?.client ?? client).get<CsrfTokenResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/csrf-token',
    ...options
});

/**
 * List document containers (paginated, with search).
 */
export const listDocumentContainers = <ThrowOnError extends boolean = false>(options?: Options<ListDocumentContainersData, ThrowOnError>) => (options?.client ?? client).get<ListDocumentContainersResponses, ListDocumentContainersErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/document-containers',
    ...options
});

/**
 * Create a new document container.
 *
 * Auto-generates a unique document number using the `PostgreSQL` sequence.
 */
export const createDocumentContainer = <ThrowOnError extends boolean = false>(options: Options<CreateDocumentContainerData, ThrowOnError>) => (options.client ?? client).post<CreateDocumentContainerResponses, CreateDocumentContainerErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/document-containers',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete a document container.
 *
 * Fails if any documents exist in the container.
 */
export const deleteDocumentContainer = <ThrowOnError extends boolean = false>(options: Options<DeleteDocumentContainerData, ThrowOnError>) => (options.client ?? client).delete<DeleteDocumentContainerResponses, DeleteDocumentContainerErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/document-containers/{id}',
    ...options
});

/**
 * Get document container detail with documents list.
 *
 * Accepts either a UUID or a document number (e.g. `PC-000042-RP`).
 */
export const getDocumentContainer = <ThrowOnError extends boolean = false>(options: Options<GetDocumentContainerData, ThrowOnError>) => (options.client ?? client).get<GetDocumentContainerResponses, GetDocumentContainerErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/document-containers/{id}',
    ...options
});

/**
 * Update a document container.
 */
export const updateDocumentContainer = <ThrowOnError extends boolean = false>(options: Options<UpdateDocumentContainerData, ThrowOnError>) => (options.client ?? client).put<UpdateDocumentContainerResponses, UpdateDocumentContainerErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/document-containers/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Mark the latest approved document version as obsolete.
 *
 * Sets the latest APPROVED version to OBSOLETE and regenerates the PDF
 * with an "OBSOLETE" watermark. Requires write permission on the container.
 */
export const obsoleteDocument = <ThrowOnError extends boolean = false>(options: Options<ObsoleteDocumentData, ThrowOnError>) => (options.client ?? client).post<ObsoleteDocumentResponses, ObsoleteDocumentErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/documents/containers/{container_id}/obsolete',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Reinstate an obsolete document version back to approved.
 *
 * Sets the latest OBSOLETE version to APPROVED and regenerates the PDF
 * without a watermark. Requires write permission on the container.
 */
export const reinstateDocument = <ThrowOnError extends boolean = false>(options: Options<ReinstateDocumentData, ThrowOnError>) => (options.client ?? client).post<ReinstateDocumentResponses, ReinstateDocumentErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/documents/containers/{container_id}/reinstate',
    ...options
});

/**
 * Upload a file to a document container.
 *
 * If the latest document is a DRAFT, it is updated in-place.
 * Otherwise a new version is created.
 */
export const uploadDocument = <ThrowOnError extends boolean = false>(options: Options<UploadDocumentData, ThrowOnError>) => (options.client ?? client).post<UploadDocumentResponses, UploadDocumentErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/documents/containers/{container_id}/upload',
    ...options
});

/**
 * Cancel a pending review.
 *
 * Deletes all pending reviews for the document and transitions it back to DRAFT.
 */
export const cancelReview = <ThrowOnError extends boolean = false>(options: Options<CancelReviewData, ThrowOnError>) => (options.client ?? client).post<CancelReviewResponses, CancelReviewErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/documents/{document_id}/cancel-review',
    ...options
});

/**
 * Submit a review decision (approve or reject).
 *
 * On approval, marks previous approved versions in the same container as OBSOLETE.
 * On rejection, transitions the document back to DRAFT.
 */
export const submitReview = <ThrowOnError extends boolean = false>(options: Options<SubmitReviewData, ThrowOnError>) => (options.client ?? client).post<SubmitReviewResponses, SubmitReviewErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/documents/{document_id}/review',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Send a document for review.
 *
 * Creates a review record and transitions the document from DRAFT to `IN_REVIEW`.
 */
export const sendForReview = <ThrowOnError extends boolean = false>(options: Options<SendForReviewData, ThrowOnError>) => (options.client ?? client).post<SendForReviewResponses, SendForReviewErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/documents/{document_id}/send-for-review',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete a DRAFT document.
 *
 * Only works on DRAFT documents where an approved version exists in the
 * same container (i.e. the draft is a "new draft after approval").
 * Deletes any pending reviews first, then the document itself.
 */
export const deleteDraft = <ThrowOnError extends boolean = false>(options: Options<DeleteDraftData, ThrowOnError>) => (options.client ?? client).delete<DeleteDraftResponses, DeleteDraftErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/documents/{id}',
    ...options
});

/**
 * Download the original file of a document.
 */
export const downloadOriginal = <ThrowOnError extends boolean = false>(options: Options<DownloadOriginalData, ThrowOnError>) => (options.client ?? client).get<DownloadOriginalResponses, DownloadOriginalErrors, ThrowOnError>({
    responseType: 'blob',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/documents/{id}/download/original',
    ...options
});

/**
 * Download the generated PDF of a document.
 */
export const downloadPdf = <ThrowOnError extends boolean = false>(options: Options<DownloadPdfData, ThrowOnError>) => (options.client ?? client).get<DownloadPdfResponses, DownloadPdfErrors, ThrowOnError>({
    responseType: 'blob',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/documents/{id}/download/pdf',
    ...options
});

/**
 * Regenerate the PDF for a document.
 *
 * Useful for retrying after a failed generation or forcing a refresh.
 */
export const regeneratePdf = <ThrowOnError extends boolean = false>(options: Options<RegeneratePdfData, ThrowOnError>) => (options.client ?? client).post<RegeneratePdfResponses, RegeneratePdfErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/documents/{id}/regenerate-pdf',
    ...options
});

/**
 * Update document status.
 *
 * Valid transitions:
 * - DRAFT → `IN_REVIEW`
 * - `IN_REVIEW` → DRAFT (rejection)
 */
export const updateDocumentStatus = <ThrowOnError extends boolean = false>(options: Options<UpdateDocumentStatusData, ThrowOnError>) => (options.client ?? client).put<UpdateDocumentStatusResponses, UpdateDocumentStatusErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/documents/{id}/status',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Bulk download documents as a zip file (streaming).
 *
 * Accepts container IDs and/or folder IDs. For a single file with a single
 * format, returns the raw file directly (no zip wrapper).
 *
 * The zip is streamed via `tokio::io::duplex` — one file is loaded from the
 * database at a time and written to the zip stream, keeping memory usage low.
 */
export const bulkDownload = <ThrowOnError extends boolean = false>(options: Options<BulkDownloadData, ThrowOnError>) => (options.client ?? client).post<BulkDownloadResponses, BulkDownloadErrors, ThrowOnError>({
    responseType: 'blob',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/downloads/bulk',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List ECRs with pagination, search, and filters.
 */
export const listEcrs = <ThrowOnError extends boolean = false>(options?: Options<ListEcrsData, ThrowOnError>) => (options?.client ?? client).get<ListEcrsResponses, ListEcrsErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/ecrs',
    ...options
});

/**
 * Create a new ECR.
 */
export const createEcr = <ThrowOnError extends boolean = false>(options: Options<CreateEcrData, ThrowOnError>) => (options.client ?? client).post<CreateEcrResponses, CreateEcrErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/ecrs',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get ECR dashboard data.
 */
export const getEcrDashboard = <ThrowOnError extends boolean = false>(options?: Options<GetEcrDashboardData, ThrowOnError>) => (options?.client ?? client).get<GetEcrDashboardResponses, GetEcrDashboardErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/ecrs/dashboard',
    ...options
});

/**
 * Export ECRs as CSV or JSON.
 */
export const getEcrExport = <ThrowOnError extends boolean = false>(options?: Options<GetEcrExportData, ThrowOnError>) => (options?.client ?? client).get<GetEcrExportResponses, GetEcrExportErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/ecrs/export',
    ...options
});

/**
 * Get ECR detail with history.
 */
export const getEcr = <ThrowOnError extends boolean = false>(options: Options<GetEcrData, ThrowOnError>) => (options.client ?? client).get<GetEcrResponses, GetEcrErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/ecrs/{ecr_number}',
    ...options
});

/**
 * Update ECR fields with diff tracking.
 */
export const updateEcr = <ThrowOnError extends boolean = false>(options: Options<UpdateEcrData, ThrowOnError>) => (options.client ?? client).put<UpdateEcrResponses, UpdateEcrErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/ecrs/{ecr_number}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Advance ECR through workflow stages.
 */
export const advanceEcr = <ThrowOnError extends boolean = false>(options: Options<AdvanceEcrData, ThrowOnError>) => (options.client ?? client).post<AdvanceEcrResponses, AdvanceEcrErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/ecrs/{ecr_number}/advance',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List history entries for an ECR (newest first).
 */
export const listEcrHistory = <ThrowOnError extends boolean = false>(options: Options<ListEcrHistoryData, ThrowOnError>) => (options.client ?? client).get<ListEcrHistoryResponses, ListEcrHistoryErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/ecrs/{ecr_number}/history',
    ...options
});

/**
 * Add a note to an ECR's history.
 */
export const addEcrNote = <ThrowOnError extends boolean = false>(options: Options<AddEcrNoteData, ThrowOnError>) => (options.client ?? client).post<AddEcrNoteResponses, AddEcrNoteErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/ecrs/{ecr_number}/history',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Export a single ECR as PDF via Gotenberg.
 */
export const getEcrPdf = <ThrowOnError extends boolean = false>(options: Options<GetEcrPdfData, ThrowOnError>) => (options.client ?? client).get<GetEcrPdfResponses, GetEcrPdfErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/ecrs/{ecr_number}/pdf',
    ...options
});

/**
 * Reclassify an ECR (admin only, `IN_REVIEW` only).
 */
export const reclassifyEcr = <ThrowOnError extends boolean = false>(options: Options<ReclassifyEcrData, ThrowOnError>) => (options.client ?? client).post<ReclassifyEcrResponses, ReclassifyEcrErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/ecrs/{ecr_number}/reclassify',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List folders (paginated).
 *
 * By default returns only top-level folders (those with no parent).
 * Pass `include_nested=true` to return all folders in the system.
 */
export const listRootFolders = <ThrowOnError extends boolean = false>(options?: Options<ListRootFoldersData, ThrowOnError>) => (options?.client ?? client).get<ListRootFoldersResponses, ListRootFoldersErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/folders',
    ...options
});

/**
 * Create a new folder.
 *
 * Creates a folder at root level or under an existing parent folder.
 * Name must be unique within the same parent (case-insensitive).
 */
export const createFolder = <ThrowOnError extends boolean = false>(options: Options<CreateFolderData, ThrowOnError>) => (options.client ?? client).post<CreateFolderResponses, CreateFolderErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/folders',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete an empty folder.
 *
 * Fails if the folder contains subfolders or document containers.
 */
export const deleteFolder = <ThrowOnError extends boolean = false>(options: Options<DeleteFolderData, ThrowOnError>) => (options.client ?? client).delete<DeleteFolderResponses, DeleteFolderErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/folders/{id}',
    ...options
});

/**
 * Get folder contents.
 *
 * Returns the folder details along with paginated subfolders, paginated
 * document containers, and breadcrumb navigation. Uses standard `ListParams`
 * for server-side search, sorting, and pagination of both collections.
 */
export const getFolderContents = <ThrowOnError extends boolean = false>(options: Options<GetFolderContentsData, ThrowOnError>) => (options.client ?? client).get<GetFolderContentsResponses, GetFolderContentsErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/folders/{id}',
    ...options
});

/**
 * Rename a folder.
 *
 * Name must be unique within the same parent (case-insensitive).
 */
export const renameFolder = <ThrowOnError extends boolean = false>(options: Options<RenameFolderData, ThrowOnError>) => (options.client ?? client).put<RenameFolderResponses, RenameFolderErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/folders/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List user IDs that have at least Read access to a folder.
 *
 * Includes system admins, system viewers, and users with explicit folder
 * permissions (read or write). Useful for filtering reviewer selection.
 */
export const getAccessibleUserIds = <ThrowOnError extends boolean = false>(options: Options<GetAccessibleUserIdsData, ThrowOnError>) => (options.client ?? client).get<GetAccessibleUserIdsResponses, GetAccessibleUserIdsErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/folders/{id}/accessible-user-ids',
    ...options
});

/**
 * Move a folder to a new parent.
 *
 * Validates that the move doesn't create a circular reference.
 * Set `parent_folder_id` to `null` to move to root.
 */
export const moveFolder = <ThrowOnError extends boolean = false>(options: Options<MoveFolderData, ThrowOnError>) => (options.client ?? client).post<MoveFolderResponses, MoveFolderErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/folders/{id}/move',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Revoke permissions from a user (admin only).
 *
 * Revokes one or more permissions in bulk. Permissions that do not exist
 * are silently ignored.
 */
export const revokePermissions = <ThrowOnError extends boolean = false>(options: Options<RevokePermissionsData, ThrowOnError>) => (options.client ?? client).delete<RevokePermissionsResponses, RevokePermissionsErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/permissions',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List all permissions (paginated, admin only).
 *
 * Returns a paginated list of all permission records in the system.
 */
export const listPermissions = <ThrowOnError extends boolean = false>(options?: Options<ListPermissionsData, ThrowOnError>) => (options?.client ?? client).get<ListPermissionsResponses, ListPermissionsErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/permissions',
    ...options
});

/**
 * Grant permissions to a user (admin only).
 *
 * Grants one or more permissions in bulk. Permissions that already exist
 * are skipped and reported in the `already_exists` field.
 */
export const grantPermissions = <ThrowOnError extends boolean = false>(options: Options<GrantPermissionsData, ThrowOnError>) => (options.client ?? client).post<GrantPermissionsResponses, GrantPermissionsErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/permissions',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Check a user's permissions (admin only).
 *
 * Checks one or more permission checks for a user and returns
 * whether each is allowed.
 */
export const checkPermissions = <ThrowOnError extends boolean = false>(options: Options<CheckPermissionsData, ThrowOnError>) => (options.client ?? client).post<CheckPermissionsResponses, CheckPermissionsErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/permissions/check',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get a user's permission summary (admin only).
 *
 * Returns all permissions for a specific user plus whether they are a system admin.
 */
export const getUserPermissions = <ThrowOnError extends boolean = false>(options: Options<GetUserPermissionsData, ThrowOnError>) => (options.client ?? client).get<GetUserPermissionsResponses, GetUserPermissionsErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/permissions/users/{user_id}',
    ...options
});

/**
 * Get accessible resources for a user (admin only).
 *
 * Returns all resource IDs a user can access for a given resource type.
 */
export const getAccessibleResources = <ThrowOnError extends boolean = false>(options: Options<GetAccessibleResourcesData, ThrowOnError>) => (options.client ?? client).get<GetAccessibleResourcesResponses, GetAccessibleResourcesErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/permissions/users/{user_id}/accessible-resources',
    ...options
});

/**
 * Create a purchase order PDF and file it in DMS.
 */
export const createPurchaseOrder = <ThrowOnError extends boolean = false>(options: Options<CreatePurchaseOrderData, ThrowOnError>) => (options.client ?? client).post<CreatePurchaseOrderResponses, CreatePurchaseOrderErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/purchase-orders',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Generate a preview PO PDF (with PREVIEW watermark).
 */
export const previewPurchaseOrder = <ThrowOnError extends boolean = false>(options: Options<PreviewPurchaseOrderData, ThrowOnError>) => (options.client ?? client).post<PreviewPurchaseOrderResponses, PreviewPurchaseOrderErrors, ThrowOnError>({
    responseType: 'blob',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/purchase-orders/preview',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get purchasing settings (creates singleton if not found).
 */
export const getSettings = <ThrowOnError extends boolean = false>(options?: Options<GetSettingsData, ThrowOnError>) => (options?.client ?? client).get<GetSettingsResponses, GetSettingsErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/purchasing/settings',
    ...options
});

/**
 * Update purchasing settings.
 */
export const updateSettings = <ThrowOnError extends boolean = false>(options: Options<UpdateSettingsData, ThrowOnError>) => (options.client ?? client).put<UpdateSettingsResponses, UpdateSettingsErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/purchasing/settings',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete company logo.
 */
export const deleteLogo = <ThrowOnError extends boolean = false>(options?: Options<DeleteLogoData, ThrowOnError>) => (options?.client ?? client).delete<DeleteLogoResponses, DeleteLogoErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/purchasing/settings/logo',
    ...options
});

/**
 * Get company logo image.
 */
export const getLogo = <ThrowOnError extends boolean = false>(options?: Options<GetLogoData, ThrowOnError>) => (options?.client ?? client).get<GetLogoResponses, GetLogoErrors, ThrowOnError>({
    responseType: 'blob',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/purchasing/settings/logo',
    ...options
});

/**
 * Upload company logo (multipart, max 2MB, image/png, image/jpeg, image/svg+xml).
 */
export const uploadLogo = <ThrowOnError extends boolean = false>(options?: Options<UploadLogoData, ThrowOnError>) => (options?.client ?? client).put<UploadLogoResponses, UploadLogoErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/purchasing/settings/logo',
    ...options
});

/**
 * List pending reviews assigned to the current user.
 */
export const listPendingReviews = <ThrowOnError extends boolean = false>(options?: Options<ListPendingReviewsData, ThrowOnError>) => (options?.client ?? client).get<ListPendingReviewsResponses, ListPendingReviewsErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/reviews',
    ...options
});

/**
 * Search document containers using hybrid full-text + trigram + ILIKE.
 */
export const search = <ThrowOnError extends boolean = false>(options?: Options<SearchData, ThrowOnError>) => (options?.client ?? client).get<SearchResponses, SearchErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/search',
    ...options
});

/**
 * List suppliers with pagination, search, and filters.
 */
export const listSuppliers = <ThrowOnError extends boolean = false>(options?: Options<ListSuppliersData, ThrowOnError>) => (options?.client ?? client).get<ListSuppliersResponses, ListSuppliersErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/suppliers',
    ...options
});

/**
 * Create a new supplier.
 */
export const createSupplier = <ThrowOnError extends boolean = false>(options: Options<CreateSupplierData, ThrowOnError>) => (options.client ?? client).post<CreateSupplierResponses, CreateSupplierErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/suppliers',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Suggest a supplier code based on the supplier name.
 */
export const suggestCode = <ThrowOnError extends boolean = false>(options: Options<SuggestCodeData, ThrowOnError>) => (options.client ?? client).get<SuggestCodeResponses, SuggestCodeErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/suppliers/suggest-code',
    ...options
});

/**
 * Delete a supplier (admin only).
 */
export const deleteSupplier = <ThrowOnError extends boolean = false>(options: Options<DeleteSupplierData, ThrowOnError>) => (options.client ?? client).delete<DeleteSupplierResponses, DeleteSupplierErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/suppliers/{id}',
    ...options
});

/**
 * Get supplier detail with notes and history.
 */
export const getSupplier = <ThrowOnError extends boolean = false>(options: Options<GetSupplierData, ThrowOnError>) => (options.client ?? client).get<GetSupplierResponses, GetSupplierErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/suppliers/{id}',
    ...options
});

/**
 * Update a supplier with automatic change history.
 */
export const updateSupplier = <ThrowOnError extends boolean = false>(options: Options<UpdateSupplierData, ThrowOnError>) => (options.client ?? client).put<UpdateSupplierResponses, UpdateSupplierErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/suppliers/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Add a note to a supplier.
 */
export const addNote2 = <ThrowOnError extends boolean = false>(options: Options<AddNote2Data, ThrowOnError>) => (options.client ?? client).post<AddNote2Responses, AddNote2Errors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/suppliers/{id}/notes',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete a supplier note.
 */
export const deleteNote = <ThrowOnError extends boolean = false>(options: Options<DeleteNoteData, ThrowOnError>) => (options.client ?? client).delete<DeleteNoteResponses, DeleteNoteErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/suppliers/{id}/notes/{note_id}',
    ...options
});

/**
 * Edit a supplier note.
 */
export const editNote = <ThrowOnError extends boolean = false>(options: Options<EditNoteData, ThrowOnError>) => (options.client ?? client).put<EditNoteResponses, EditNoteErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/suppliers/{id}/notes/{note_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List active users for dropdowns (e.g. reviewer selection).
 *
 * Returns all active users with id and name. Available to any authenticated user.
 */
export const listActiveUsers = <ThrowOnError extends boolean = false>(options?: Options<ListActiveUsersData, ThrowOnError>) => (options?.client ?? client).get<ListActiveUsersResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/users',
    ...options
});

/**
 * Update the current user's profile.
 *
 * Allows updating name and/or email. Email must be unique across all users.
 */
export const updateProfile = <ThrowOnError extends boolean = false>(options: Options<UpdateProfileData, ThrowOnError>) => (options.client ?? client).put<UpdateProfileResponses, UpdateProfileErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/users/me',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Disable two-factor authentication.
 *
 * Requires a valid TOTP code for security verification before disabling.
 */
export const disable2Fa = <ThrowOnError extends boolean = false>(options: Options<Disable2FaData, ThrowOnError>) => (options.client ?? client).post<Disable2FaResponses, Disable2FaErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/users/me/2fa/disable',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Enable two-factor authentication.
 *
 * Requires a valid TOTP code from the authenticator app to confirm
 * the secret was correctly set up.
 */
export const enable2Fa = <ThrowOnError extends boolean = false>(options: Options<Enable2FaData, ThrowOnError>) => (options.client ?? client).post<Enable2FaResponses, Enable2FaErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/users/me/2fa/enable',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Generate a TOTP secret for 2FA setup.
 *
 * Returns the secret and a provisioning URI for QR code generation.
 * The secret is stored but 2FA is not enabled until confirmed with
 * `POST /2fa/enable`.
 */
export const generate2Fa = <ThrowOnError extends boolean = false>(options?: Options<Generate2FaData, ThrowOnError>) => (options?.client ?? client).post<Generate2FaResponses, Generate2FaErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/users/me/2fa/generate',
    ...options
});

/**
 * Get the current user's accessible resources for a given type.
 *
 * Returns all resource IDs the authenticated user has permissions on
 * for the requested resource type.
 */
export const getMyAccessibleResources = <ThrowOnError extends boolean = false>(options: Options<GetMyAccessibleResourcesData, ThrowOnError>) => (options.client ?? client).get<GetMyAccessibleResourcesResponses, GetMyAccessibleResourcesErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/users/me/accessible-resources',
    ...options
});

/**
 * List the current user's registered passkeys.
 */
export const listPasskeys = <ThrowOnError extends boolean = false>(options?: Options<ListPasskeysData, ThrowOnError>) => (options?.client ?? client).get<ListPasskeysResponses, ListPasskeysErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/users/me/passkeys',
    ...options
});

/**
 * Complete passkey registration.
 *
 * Verifies the credential response and stores the passkey in the database.
 */
export const registerFinish = <ThrowOnError extends boolean = false>(options: Options<RegisterFinishData, ThrowOnError>) => (options.client ?? client).post<RegisterFinishResponses, RegisterFinishErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/users/me/passkeys/register/finish',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Start passkey registration.
 *
 * Returns `WebAuthn` creation options that the browser passes to
 * `navigator.credentials.create()`. Challenge state is stored in the cache.
 */
export const registerStart = <ThrowOnError extends boolean = false>(options: Options<RegisterStartData, ThrowOnError>) => (options.client ?? client).post<RegisterStartResponses, RegisterStartErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/users/me/passkeys/register/start',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete a registered passkey.
 */
export const deletePasskey = <ThrowOnError extends boolean = false>(options: Options<DeletePasskeyData, ThrowOnError>) => (options.client ?? client).delete<DeletePasskeyResponses, DeletePasskeyErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/users/me/passkeys/{passkey_id}',
    ...options
});

/**
 * Change the current user's password.
 *
 * Requires the current password for verification. The new password must
 * meet strength requirements (uppercase, lowercase, digit, special character).
 */
export const changePassword = <ThrowOnError extends boolean = false>(options: Options<ChangePasswordData, ThrowOnError>) => (options.client ?? client).put<ChangePasswordResponses, ChangePasswordErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/users/me/password',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get the current user's permission summary.
 *
 * Returns all direct and inherited permissions for the authenticated user.
 */
export const getMyPermissions = <ThrowOnError extends boolean = false>(options?: Options<GetMyPermissionsData, ThrowOnError>) => (options?.client ?? client).get<GetMyPermissionsResponses, GetMyPermissionsErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/users/me/permissions',
    ...options
});

/**
 * Check multiple permissions for the current user.
 *
 * Returns whether each requested permission is granted and the source
 * of the grant (system admin, direct grant, or inherited from parent).
 */
export const checkMyPermissions = <ThrowOnError extends boolean = false>(options: Options<CheckMyPermissionsData, ThrowOnError>) => (options.client ?? client).post<CheckMyPermissionsResponses, CheckMyPermissionsErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/users/me/permissions/check',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Basic health check with database status.
 */
export const health = <ThrowOnError extends boolean = false>(options?: Options<HealthData, ThrowOnError>) => (options?.client ?? client).get<HealthResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/health',
    ...options
});

/**
 * Comprehensive health check with pool, latency, and DB metrics.
 */
export const healthDetailed = <ThrowOnError extends boolean = false>(options?: Options<HealthDetailedData, ThrowOnError>) => (options?.client ?? client).get<HealthDetailedResponses, unknown, ThrowOnError>({ url: '/health/detailed', ...options });

/**
 * Kubernetes liveness probe.
 *
 * Always returns 200 — proves the process is running.
 * No dependency checks; use `/health/ready` for that.
 */
export const live = <ThrowOnError extends boolean = false>(options?: Options<LiveData, ThrowOnError>) => (options?.client ?? client).get<LiveResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/health/live',
    ...options
});

/**
 * Kubernetes readiness probe.
 *
 * Checks database connectivity (`SELECT 1`).
 * Returns 200 if all dependencies are reachable, 503 otherwise.
 */
export const ready = <ThrowOnError extends boolean = false>(options?: Options<ReadyData, ThrowOnError>) => (options?.client ?? client).get<ReadyResponses, ReadyErrors, ThrowOnError>({
    responseType: 'json',
    url: '/health/ready',
    ...options
});

/**
 * Build version information.
 *
 * Returns the crate version, git commit SHA, and build date.
 * Commit and build date are set at compile time via environment variables.
 */
export const version = <ThrowOnError extends boolean = false>(options?: Options<VersionData, ThrowOnError>) => (options?.client ?? client).get<VersionResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/health/version',
    ...options
});
